module.exports = __webpack_public_path__ + "static/media/meter-conservative.ed76f244.svg";